module.exports = __webpack_public_path__ + "img/16.70639ca.png";